import { css, html, LitElement } from "lit";
import { provide } from '@lit/context';
import { customElement, property } from 'lit/decorators.js';
import { editModeContext } from 'src/context/content-context';

import { CtxCard } from "src/components/ctx-card";
CtxCard;

import { YouTubeCard } from 'src/components/youtube-card';
YouTubeCard;

import { ColleagueAudit } from "./colleague-audit";
ColleagueAudit;

import { ThalamusHero } from 'src/components/thalamus-hero';
ThalamusHero;

import { CtxHero } from 'src/components/ctx-hero';
CtxHero;

import { ReportNews } from "../components/report-news";
ReportNews;

import { SubscriberKeyProvider } from "src/context/components/subscriber-key-provider";
SubscriberKeyProvider;

// markup view ensures all required components are available
// content doesn't need to be in a slot
@customElement('markup-viewer')
export class MarkupViewer extends LitElement {

  @provide({ context: editModeContext })
  @property({ type: Boolean, attribute: 'edit-mode' })
  editMode: boolean = false;

  render() {
    return html`
      <slot></slot>
    `;
  }
}